<div class="modal-overlay" [class.open]="open" (click)="onOverlayClick($event)">
  <div class="modal" role="dialog" aria-modal="true" aria-labelledby="demoModalTitle">
    <div class="modal-head">
      <span class="eyebrow">{{ 'demo.eyebrow' | translate }}</span>
      <h2 id="demoModalTitle">{{ 'demo.title' | translate }}</h2>
      <p>{{ 'demo.subtitle' | translate }}</p>
      <button class="modal-close" type="button" (click)="close()" [attr.aria-label]="'demo.close' | translate">✕</button>
    </div>

    <div class="modal-body">
      <form #demoForm="ngForm" (ngSubmit)="submit(demoForm)" *ngIf="!sent">
        <div class="form-grid">
          <!-- Columna izquierda: datos del solicitante -->
          <div class="fg-col">
            <!-- Nombre de la empresa -->
            <div class="field">
              <label for="empresa">{{ 'demo.empresaLabel' | translate }} <span class="req">*</span></label>
              <input type="text" id="empresa" name="empresa" required
                     [(ngModel)]="empresa" [placeholder]="'demo.empresaPlaceholder' | translate">
            </div>

            <!-- Rol de la empresa -->
            <div class="field">
              <label for="rol">{{ 'demo.rolLabel' | translate }} <span class="req">*</span></label>
              <select id="rol" name="rol" required
                      [ngModel]="rol" (ngModelChange)="onRolChange($event)">
                <option value="" disabled>{{ 'demo.rolPlaceholder' | translate }}</option>
                <option *ngFor="let r of roles" [value]="r">{{ r }}</option>
              </select>
              <div class="otros-field" [class.show]="rolOtros">
                <input type="text" name="rolOtrosTexto" [(ngModel)]="rolOtrosTexto"
                       [placeholder]="'demo.rolOtrosPlaceholder' | translate">
              </div>
            </div>

            <!-- Persona de contacto -->
            <div class="field">
              <label for="contacto">{{ 'demo.contactoLabel' | translate }} <span class="req">*</span></label>
              <input type="text" id="contacto" name="contacto" required
                     [(ngModel)]="contacto" [placeholder]="'demo.contactoPlaceholder' | translate">
            </div>

            <!-- Email de contacto -->
            <div class="field">
              <label for="email">{{ 'demo.emailLabel' | translate }} <span class="req">*</span></label>
              <input type="email" id="email" name="email" required email
                     [(ngModel)]="email" [placeholder]="'demo.emailPlaceholder' | translate">
            </div>
          </div>

          <!-- Columna derecha: productos que gestiona -->
          <div class="fg-col">
            <div class="field">
              <label>{{ 'demo.productosLabel' | translate }} <span class="req">*</span></label>
              <div class="checkbox-grid">
                <label class="check" *ngFor="let p of productos">
                  <input type="checkbox" [checked]="productosSel.has(p)"
                         (change)="onProducto(p, $any($event.target).checked)"> {{ p }}
                </label>
                <label class="check">
                  <input type="checkbox" [checked]="otrosChecked"
                         (change)="onOtros($any($event.target).checked)"> {{ 'demo.productosOtros' | translate }}
                </label>
              </div>
              <div class="otros-field" [class.show]="otrosChecked">
                <input type="text" name="otrosTexto" [(ngModel)]="otrosTexto"
                       [placeholder]="'demo.otrosPlaceholder' | translate">
              </div>
              <p class="field-error" *ngIf="showProductosError">{{ 'demo.productosError' | translate }}</p>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn ghost" type="button" (click)="close()">{{ 'demo.cancel' | translate }}</button>
          <button class="btn solid" type="submit">{{ 'demo.submit' | translate }}</button>
        </div>
      </form>

      <!-- Confirmación -->
      <div class="sent" [class.show]="sent">
        <div class="ico">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        </div>
        <h3>{{ 'demo.sentTitle' | translate }}</h3>
        <p>{{ 'demo.sentText' | translate }}</p>
        <div class="form-actions" style="justify-content:center">
          <button class="btn solid" type="button" (click)="close()">{{ 'demo.close' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
